<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-card class="cardClassDetailInfo" :noHeader="true">
        <template slot="card-detail">
          <div class="col-3">
            <c-label-text title="사업장" :value="param.plantName"></c-label-text>
          </div>
          <div class="col-3">
            <c-label-text title="설비유형" :value="param.equipmentTypeName"></c-label-text>
          </div>
          <div class="col-3">
            <c-label-text title="설비관리번호" :value="param.equipmentNo"></c-label-text>
          </div>
          <div class="col-3">
            <c-label-text title="설비명" :value="param.equipmentName"></c-label-text>
          </div>
        </template>
      </c-card>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="itemTable1"
        title="일상점검항목 목록"
        :columns="grid1.columns"
        :editable="editable"
        :data="grid1.data"
        selection="multiple"
        :usePaging="false"
        gridHeight="350px"
        :expandAll="true"
        rowKey="checkItemId"
      >
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name === 'checkItemPartName'">
            <c-text-column
              :editable="editable"
              :col="col"
              :props="props"
              @datachange="datachange(props, col)"
            >
            </c-text-column>
            <span>
              <div>
                <q-btn-group outline class="ColumInnerBtnGroup">
                  <template v-for="(btn, idx) in col.btns">
                    <q-btn
                      :key="idx"
                      :label="btn.label"
                      :icon="btn.icon ? btn.icon : void 0"
                      :color="btn.color ? btn.color : 'blue-grey-4'"
                      :text-color="btn.textColor ? btn.textColor : 'white'"
                      class="ColumInnerBtn"
                      align="center"
                      @click.stop="innerBtnClicked(col, props, btn)">
                      <q-tooltip v-if="btn.tooltip">
                        <span v-html="btn.tooltip" />
                      </q-tooltip>
                    </q-btn>
                  </template>
                </q-btn-group>
              </div>
            </span>
          </template>
        </template>
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="editable" label="추가" icon="add" :showLoading="false" @btnClicked="addrow1" />
            <c-btn v-if="editable && grid1.data.length > 0" :showLoading="false" label="삭제" icon="remove" @btnClicked="remove1"/>
            <c-btn
              v-if="editable && grid1.data.length > 0"
              :url="saveUrl1"
              :isSubmit="isSave1"
              :param="grid1.data"
              mappingType="POST"
              label="저장"
              icon="save"
              @beforeAction="saveClass1"
              @btnCallback="saveCallback" />
          </q-btn-group>
        </template>
      </c-table> 
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="itemTable2"
        title="열화관리항목 목록"
        :columns="grid2.columns"
        :data="grid2.data"
        :editable="editable"
        selection="multiple"
        :usePaging="false"
        gridHeight="350px"
        :expandAll="true"
        rowKey="checkItemId"
      > 
      
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="editable" label="추가" icon="add" :showLoading="false" @btnClicked="addrow2" />
            <c-btn v-if="editable && grid2.data.length > 0" :showLoading="false" label="삭제" icon="remove" @btnClicked="remove2"/>
            <c-btn
              v-if="editable && grid2.data.length > 0"
              :url="saveUrl2"
              :isSubmit="isSave2"
              :param="grid2.data"
              mappingType="POST"
              label="저장"
              icon="save"
              @beforeAction="saveClass2"
              @btnCallback="saveCallback" />
          </q-btn-group>
        </template>
      </c-table> 
    </div>
  </div>
</template>
<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'equipment-item',
  props: {
    param: {
      type: Object,
      default: () => ({
        equipmentCd: '',
        equipmentTypeCd: '',
        equipmentNo: '',
        plantName: '',
        plantCd: '',
        processCds: [],
        equipmentTypeName: '',
        equipmentName: '',
      }),
    },
  },
  data() {
    return {
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      editable: true,
      grid1: {
        columns: [
        ],
        data: [],
      },
      grid2: {
        columns: [
        ],
        data: [],
      },
      listUrl1: '',
      listUrl2: '',
      isSave1: false,
      isSave2: false,
      saveType: 'POST',
      saveUrl1: '',
      saveUrl2: '',
      deleteUrl1: '',
      deleteUrl2: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
    // 'equipmentTypeCd'() {
    //   this.getList();
    //   this.getList2();
    // },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;

      this.listUrl1 = selectConfig.mdm.equipment.daily.list.url;
      this.listUrl2 = selectConfig.mdm.equipment.deterior.list.url;
      this.saveUrl1 = transactionConfig.mdm.equipment.daily.save.url;
      this.deleteUrl1 = transactionConfig.mdm.equipment.daily.delete.url;
      this.saveUrl2 = transactionConfig.mdm.equipment.deterior.save.url;
      this.deleteUrl2 = transactionConfig.mdm.equipment.deterior.delete.url;

      this.setHeader();
      this.getList();
      this.getList2();
    },
    getList() {
      // 전체조회
      this.$http.url = this.listUrl1;
      this.$http.type = 'GET';
      this.$http.param = { equipmentCd: this.param.equipmentCd, equipmentTypeCd: this.param.equipmentTypeCd };
      this.$http.request((_result) => {
        this.grid1.data = _result.data;

        this.$_.forEach(this.grid1.data, _item => {
          _item.equipmentCd = this.param.equipmentCd;
        })
      },);
    },
    getList2() {
      // 전체조회
      this.$http.url = this.listUrl2;
      this.$http.type = 'GET';
      this.$http.param = { equipmentCd: this.param.equipmentCd, equipmentTypeCd: this.param.equipmentTypeCd };
      this.$http.request((_result) => {
        this.grid2.data = _result.data;

        this.$_.forEach(this.grid2.data, _item => {
          _item.equipmentCd = this.param.equipmentCd;
        })
      },);
    },
    setHeader() {
      this.$comm.getComboItems('MDM_CHECK_CYCLE_CD').then(_result => {
        this.grid1.columns = [
          {
            required: true,
            name: 'checkItemPartName',
            field: 'checkItemPartName',
            label: '부품명',
            btns: [
              { label: '', icon: 'add', color: 'orange', tooltip: '부품명 추가' },
            ],
            style: 'width:300px',
            type: 'custom',
            align: 'left',
            sortable: false,
          },
          {
            name: 'checkItemName',
            field: 'checkItemName',
            label: '점검항목',
            style: 'width:200px',
            type: 'text',
            align: 'left',
            sortable: false,
          },
          {
            name: 'checkItemMethod',
            field: 'checkItemMethod',
            label: '점검방법',
            style: 'width:200px',
            type: 'text',
            align: 'left',
            sortable: false,
          },
          {
            name: 'checkStandard',
            field: 'checkStandard',
            label: '점검기준',
            style: 'width:200px',
            type: 'text',
            align: 'left',
            sortable: false,
          },
          {
            required: true,
            name: 'checkItemCycleCd',
            field: 'checkItemCycleCd',
            label: '주기',
            align: 'center',
            style: 'width:80px',
            type: 'select',
            comboItems: _result,
            sortable: false,
          },
          {
            name: 'sortOrder',
            field: 'sortOrder',
            label: '정렬순서',
            style: 'width:70px',
            type: 'number',
            align: 'left',
            sortable: false,
          },
        ];
        this.grid2.columns = [
          {
            required: true,
            name: 'checkItemPartName',
            field: 'checkItemPartName',
            label: '열화관리 Part',
            style: 'width:200px',
            type: 'text',
            align: 'left',
            sortable: false,
          },
          {
            name: 'checkStandard',
            field: 'checkStandard',
            label: '점검기준',
            style: 'width:200px',
            type: 'text',
            align: 'left',
            sortable: false,
          },
          {
            required: true,
            name: 'checkItemCycleCd',
            field: 'checkItemCycleCd',
            label: '주기',
            align: 'center',
            style: 'width:80px',
            type: 'select',
            comboItems: _result,
            sortable: false,
          },
          {
            name: 'sortOrder',
            field: 'sortOrder',
            label: '정렬순서',
            style: 'width:70px',
            type: 'number',
            align: 'left',
            sortable: false,
          },
        ];
      })
    },
    addrow1() {
      // 초기에는 userId에 tempId를 부여
      this.grid1.data.push({
        equipmentCd: this.param.equipmentCd,
        checkItemId: uid(),
        equipmentCheckTypeCd: null,
        checkItemPartCd: '',
        checkItemPartName: '',
        checkItemCycleCd: null,
        checkItemName: '',
        checkItemMethod: '',
        checkStandard: '',
        sortOrder: this.grid1.data.length + 1,
        regUserId: this.$store.getters.user.userId,
        chgUserId: this.$store.getters.user.userId,
        editFlag: 'C',
      })
    },
    saveClass1() {
      let isConti = true;
      let checkItem = ['checkItemPartName', 'checkItemCycleCd']
      this.$_.forEach(this.grid1.data, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      }); 
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [부품명, 주기]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.isSave1 = !this.isSave1;
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getList();
      this.getList2();
    },
    innerBtnClicked(col, props) {
      this.grid1.data.splice(props.rowIndex+1, 0, {
        equipmentCd: this.param.equipmentCd,
        checkItemId: uid(),
        equipmentCheckTypeCd: null,
        checkItemPartCd: '',
        checkItemPartName: props.row.checkItemPartName,
        checkItemCycleCd: null,
        checkItemName: '',
        checkItemMethod: '',
        checkStandard: '',
        sortOrder: Number(props.row.sortOrder) + 1,
        regUserId: this.$store.getters.user.userId,
        chgUserId: this.$store.getters.user.userId,
        editFlag: 'C',
      })
    },
    remove1() {
      let selectData = this.$refs['itemTable1'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.deleteUrl1;
          this.$http.type = 'DELETE';
          this.$http.param = {
            data: Object.values(selectData)
          }
          this.$http.request(() => {
            this.$_.forEach(selectData, item => {
              this.grid1.data = this.$_.reject(this.grid1.data, { checkItemId: item.checkItemId })
            })
            window.getApp.$emit('APP_REQUEST_SUCCESS');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
      }
    },
    
    addrow2() {
      // 초기에는 userId에 tempId를 부여
      this.grid2.data.push({
        equipmentCd: this.param.equipmentCd,
        checkItemId: uid(),
        equipmentCheckTypeCd: null,
        checkItemPartCd: '',
        checkItemPartName: '',
        checkItemCycleCd: null,
        checkStandard: '',
        sortOrder: this.grid2.data.length + 1,
        regUserId: this.$store.getters.user.userId,
        chgUserId: this.$store.getters.user.userId,
        editFlag: 'C',
      })
    },
    datachange(props) {
      if (props.row['editFlag'] !== 'C') {
        props.row['editFlag'] = 'U'
        props.row['chgUserId'] = this.$store.getters.user.userId
      }
    },
    saveClass2() {
      let isConti = true;
      let checkItem = ['checkItemPartName', 'checkItemCycleCd']
      this.$_.forEach(this.grid2.data, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      }); 
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [열화관리Part, 주기]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.isSave2 = !this.isSave2;
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    remove2() {
      let selectData = this.$refs['itemTable2'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.deleteUrl2;
          this.$http.type = 'DELETE';
          this.$http.param = {
            data: Object.values(selectData)
          }
          this.$http.request(() => {
            this.$_.forEach(selectData, item => {
              this.grid2.data = this.$_.reject(this.grid2.data, { checkItemId: item.checkItemId })
            })
            window.getApp.$emit('APP_REQUEST_SUCCESS');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
      }
    },
  }
};
</script>